import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AccountTariffsModule } from '../../components/account-tariffs/account-tariffs.module';

import { BreadcrumbsComponent } from '@personal-area/global/navigation-layout';
import { Type } from '@personal-area/global/users/models';

@Component({
    templateUrl: './tariff-list.component.html',
    styleUrls: ['./tariff-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccountTariffsModule, BreadcrumbsComponent]
})
export class TariffListComponent {
  public accountType: Type;
  public isToggleAvailable: boolean;
  public availableTariffs: string[];

  constructor(
    route: ActivatedRoute,
  ) {
    const snapshot = route.snapshot;

    this.accountType = snapshot.data['accountType'] || Type.Trader;
    this.isToggleAvailable = (snapshot.queryParams['availableToggler'] ?? 'true') === 'true';
    this.availableTariffs = snapshot.queryParams['tariffs']?.split(',') ?? [];
  }
}
